import React from 'react';
import { Select } from 'antd';

type Props = {
  value: number[];
  onChange: (value: number[]) => void;
  placeholder?: string;
  style?: React.CSSProperties;
};

export default function SongsSelect({
  value = [],
  onChange,
  placeholder = 'Enter song IDs',
  style
}: Props) {
  const handleChange = (newValue: string[]) => {
    // Convert string values to numbers and filter out any invalid numbers
    const numberValues = newValue.map((val) => Number(val)).filter((num) => !isNaN(num));
    onChange(numberValues);
  };

  const handleSearch = (search: string) => {
    if (search.includes(',')) {
      const newIds = search
        .split(',')
        .map((id) => Number(id.trim()))
        .filter((num) => !isNaN(num));
      if (newIds.length > 0) {
        onChange([...value, ...newIds]);
      }
      return;
    }
  };

  // Convert numbers to strings for the Select component
  const stringValues = value.map((num) => num.toString());

  return (
    <Select
      mode="tags"
      style={{ width: '100%', ...style }}
      placeholder={placeholder}
      onChange={handleChange}
      value={stringValues}
      onSearch={handleSearch}
      tokenSeparators={[',']}
      open={false}
    />
  );
}
